import api from '../axios';

// 하도급 계약
// 계약 목록 조회 (필터 지원)
export const getSubContracts = (projectId, params = {}) =>
  api.get(`contract/sub_contract/${projectId}/`, { params}).then(res => res.data);

// 계약 상세 조회
export const getSubContractDetail = (subcontractId) =>
  api.get(`contract/sub_contract/detail/${subcontractId}/`)
     .then(res => res.data);

// 계약 생성 (파일 포함 가능)
export const createSubContract = (data) =>
  api.post('contract/sub_contract/create/', data, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);

// 계약 수정 (파일 포함 가능)
export const updateSubContract = (subcontractId, data) =>
  api.put(`contract/sub_contract/update/${subcontractId}/`, data, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);

// 계약 삭제
export const deleteSubContract = (subcontractId) =>
  api.delete(`contract/sub_contract/delete/${subcontractId}/`)
     .then(res => res.data);